const MARKET_INDICATORS_ACTION_TYPES = {
  FETCH_MARKET_INDICATORS_REQUEST: "FETCH_MARKET_INDICATORS_REQUEST",
  FETCH_MARKET_INDICATORS_SUCCESS: "FETCH_MARKET_INDICATORS_SUCCESS",
  FETCH_MARKET_INDICATORS_FAILURE: "FETCH_MARKET_INDICATORS_FAILURE"
};

export default MARKET_INDICATORS_ACTION_TYPES;
